var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#130F40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 18.1221C10.4013 13.4291 12.9448 9.80228 16.8465 8.51716C22.4372 6.67579 28.4485 9.88566 29.4557 16.0138C29.95 19.0216 29.1675 21.7292 27.2161 24.0908C25.105 26.6455 22.9807 28.941 20.8625 31.49C20.2982 32.1691 19.6949 32.1696 19.1339 31.4937C16.9303 28.8384 14.703 26.4505 12.5293 23.7713C11.0804 21.9854 10.4222 19.8983 10.4 18.1221ZM20.0041 13.6006C17.911 13.6035 16.2269 15.2728 16.2292 17.3422C16.2315 19.3885 17.9254 21.056 20.0029 21.0572C22.0678 21.0584 23.7685 19.3726 23.7641 17.3288C23.7597 15.2718 22.0713 13.5978 20.0041 13.6006Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.7d9c4b83c870d6d4f428602a9de43ed8.svg";
export { ForwardRef as ReactComponent };